import { fetcher } from '@commenda/utils';

export async function deleteRecurringTask(taskId: string): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const response = await fetcher(`recurringUserTasks/${taskId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));

      let errorMessage = 'Failed to delete task';
      if (response.status === 404) {
        errorMessage = errorData.message || 'Task not found';
      } else if (response.status === 403) {
        errorMessage =
          errorData.message || "You don't have permission to delete this task";
      }

      return {
        success: false,
        error: errorMessage,
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: 'An unexpected error occurred',
    };
  }
}
